import { createContext } from "react";
import { IFieldValue } from "./models/models";
import { Dictionary } from "lodash";

export const FieldContext = createContext<Dictionary<IFieldValue[]> | undefined>(undefined);
